import { __decorate } from "tslib";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { InstructorTableRowType } from "@/enums/InstructorTableRowType";
import InstructorTableKidSchoolCell from "@/classes/InstructorTableKidSchoolCell";
import InstructorsTableBase from "@/classes/InstructorsTableBase";
import { InstructorTableCellType } from "@/enums/InstructorTableCellType";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { NotificationTypes } from "@/enums/NotificationTypes";
import store from "@/store";
import Snackbar from "@/components/Snackbar.vue";
import { isDesktop } from "@/utils/isDesktop";
let InstructorsTableKidSchoolCell = class InstructorsTableKidSchoolCell extends InstructorsTableBase {
    //<editor-fold desc="Props">
    cellData;
    dataSource;
    //</editor-fold>
    dialog = false;
    loading = false;
    togglingPremium = false;
    togglingLeader = false;
    //<editor-fold desc="Methods">
    async togglePremium() {
        this.togglingPremium = true;
        if (!this.cellData.isPremium) {
            if (!await ConfirmDialog.open('Potvrzení', 'Opravdu chcete lekci označit jako prémiovou?')) {
                this.togglingPremium = false;
                return;
            }
        }
        this.cellData.isPremium = !this.cellData.isPremium;
        const kidSchool = await this.$store.dispatch('kidSchool/getById', this.cellData.id);
        await this.$store.dispatch('kidSchool/update', {
            ...kidSchool,
            datetime: kidSchool.dateTime,
            isPremium: this.cellData.isPremium,
            center: process.env.VUE_APP_AREAL_ID,
        });
        await this.updateDataSource();
        this.togglingPremium = false;
    }
    async changeLeader(instructorId) {
        this.togglingLeader = true;
        this.cellData.leaderId = this.cellData.leaderId !== instructorId ? instructorId : '';
        const kidSchool = await this.$store.dispatch('kidSchool/getById', this.cellData.id);
        await this.$store.dispatch('kidSchool/update', {
            ...kidSchool,
            datetime: kidSchool.dateTime,
            leaderId: this.cellData.leaderId,
            center: process.env.VUE_APP_AREAL_ID,
        });
        await this.updateDataSource();
        this.togglingLeader = false;
    }
    async isKidSchoolExisting() {
        try {
            await this.$store.dispatch('kidSchool/getById', this.cellData.id);
            return true;
        }
        catch {
            Snackbar.error('Školka již neexistuje!');
            await this.updateDataSource();
            return false;
        }
    }
    async addKidSchoolToCurrentUser() {
        this.loading = true;
        if (!await this.isKidSchoolExisting()) {
            this.loading = false;
            return;
        }
        const currentUserRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && x.isCurrentUserRow());
        if (currentUserRow === undefined) {
            this.loading = false;
            return;
        }
        const hours = Array(this.cellData.hourTo - this.cellData.hourFrom + (this.cellData.minuteTo === 0 ? 0 : 1))
            .fill(this.cellData.hourFrom).map((e, i) => e + i);
        for (const hour of hours) {
            const cellIndex = currentUserRow.cells.findIndex(x => x.hour === hour);
            if (cellIndex !== -1) {
                currentUserRow.cells.splice(cellIndex, 1);
            }
        }
        const instructorCell = new InstructorTableKidSchoolCell();
        instructorCell.hour = this.cellData.hourFrom;
        instructorCell.kidSchoolId = this.cellData.id;
        instructorCell.length = this.cellData.hourTo - this.cellData.hourFrom + (this.cellData.minuteTo === 0 ? 0 : 1);
        currentUserRow.cells.push(instructorCell);
        await this.updateDataSource();
        this.loading = false;
    }
    async removeKidSchoolUser(callbackSearch, confirmTexts) {
        this.loading = true;
        if (!await this.isKidSchoolExisting()) {
            this.loading = false;
            return false;
        }
        const userRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && callbackSearch(x));
        if (userRow === undefined) {
            this.loading = false;
            return false;
        }
        const cellIndex = userRow.cells.findIndex(x => x.cellType === InstructorTableCellType.KID_SCHOOL
            && x.kidSchoolId === this.cellData.id);
        if (cellIndex === -1) {
            this.loading = false;
            return false;
        }
        if (!await ConfirmDialog.open(confirmTexts.title, confirmTexts.text, confirmTexts.confirm, confirmTexts.cancel)) {
            this.loading = false;
            return false;
        }
        userRow.cells.splice(cellIndex, 1);
        await this.updateDataSource();
        this.loading = false;
        return true;
    }
    async removeKidSchoolToCurrentUser() {
        return this.removeKidSchoolUser((instructor) => instructor.isCurrentUserRow(), {
            title: 'Upozornění',
            text: 'Pokud se nemůžeš dostavit, neprodleně o tom informuj vedoucího školky!',
            confirm: 'Rozumím',
            cancel: 'Zrušit'
        });
    }
    async removeInstructorFromKidSchool(instructorId) {
        const result = await this.removeKidSchoolUser((instructor) => instructor.instructorId === instructorId, {
            title: 'Upozornění',
            text: 'Opravdu chcete odebrat instruktora?',
            confirm: 'Ano',
            cancel: 'Zrušit'
        });
        if (result) {
            await store.dispatch('notification/send', {
                instructor: instructorId,
                message: `Byl jste odebrán ze školky dne ${this.dataSource.date.format('D. M. YYYY')}
                    od ${this.cellData.hourFrom}:${this.cellData.minuteFrom}.`,
                type: NotificationTypes.WARNING,
                urgency: this.notificationUrgency,
                link: { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } }
            });
        }
        return result;
    }
    async removeKidSchool() {
        if (!await this.isKidSchoolExisting()) {
            return;
        }
        if (!(await ConfirmDialog.open('Mazání školky', 'Opravdu si přejete smazat školku?'))) {
            return;
        }
        try {
            await this.$store.dispatch("kidSchool/destroy", this.cellData.id);
        }
        catch (e) {
            Snackbar.warning('Školka nemohla být smazána, jelikož jsou k ní přihlášeni klienti.');
            return;
        }
        for (const instructorId of this.cellData.instructorIds) {
            const userRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
                && x.instructorId === instructorId);
            if (userRow === undefined) {
                return;
            }
            const cellIndex = userRow.cells.findIndex(x => x.cellType === InstructorTableCellType.KID_SCHOOL
                && x.kidSchoolId === this.cellData.id);
            if (cellIndex === -1) {
                return;
            }
            userRow.cells.splice(cellIndex, 1);
            await store.dispatch('notification/send', {
                instructor: instructorId,
                message: `Školka dne ${this.dataSource.date.format('D. M. YYYY')}
                    od ${this.cellData.hourFrom}:${this.cellData.minuteFrom} byla zrušena`,
                type: NotificationTypes.WARNING,
                urgency: this.notificationUrgency,
                link: { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } }
            });
        }
        await this.updateDataSource();
    }
    async editKidSchool() {
        if (!await this.isKidSchoolExisting()) {
            return;
        }
        this.$emit('editKidSchool', this.cellData);
    }
    //</editor-fold>
    //<editor-fold desc="Getters">
    get isDesktop() {
        return isDesktop();
    }
    get isRemoveButtonVisible() {
        const currentUserRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && x.isCurrentUserRow());
        if (currentUserRow === undefined) {
            return false;
        }
        const cellIndex = currentUserRow.cells.findIndex(x => x.cellType === InstructorTableCellType.KID_SCHOOL
            && x.kidSchoolId === this.cellData.id);
        if (cellIndex === -1) {
            return false;
        }
        return true;
    }
    get isAddButtonVisible() {
        if (this.isRemoveButtonVisible) {
            return false;
        }
        const currentUserRow = this.dataSource.rows.find(x => x.rowType === InstructorTableRowType.INSTRUCTOR
            && x.isCurrentUserRow());
        if (currentUserRow === undefined) {
            return false;
        }
        const hours = Array(this.cellData.hourTo - this.cellData.hourFrom + (this.cellData.minuteTo === 0 ? 0 : 1))
            .fill(this.cellData.hourFrom).map((e, i) => e + i);
        for (const cell of currentUserRow.cells.filter(x => x.cellType !== InstructorTableCellType.AVAILABLE && x.cellType !== InstructorTableCellType.PAUSE)) {
            for (let i = 0; i < cell.length; i++) {
                if (hours.some(x => x === i + cell.hour)) {
                    return false;
                }
            }
        }
        return true;
    }
    get timeString() {
        return `${this.cellData.hourFrom}:${this.cellData.minuteFrom === 0 ? '00' : this.cellData.minuteFrom}
        - ${this.cellData.hourTo}:${this.cellData.minuteTo === 0 ? '00' : this.cellData.minuteTo}`;
    }
    isModerator() {
        return this.$store.getters['user/isModerator'];
    }
};
__decorate([
    Prop({ required: true })
], InstructorsTableKidSchoolCell.prototype, "cellData", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableKidSchoolCell.prototype, "dataSource", void 0);
InstructorsTableKidSchoolCell = __decorate([
    Component
], InstructorsTableKidSchoolCell);
export default InstructorsTableKidSchoolCell;
